var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7329 70H8.30861C3.73887 70 0 66.3027 0 61.6914V8.30861C0 3.73887 3.69733 0 8.30861 0H61.7329C66.3027 0 70.0415 3.69733 70.0415 8.30861V61.7329C70.0415 66.3027 66.3027 70 61.7329 70Z",
    fill: "#CC287B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.834 23.1426H38.1992V49H33.3125V27.7656H27.9863L30.834 23.1426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.5e5abf2d6dc3d3d48c8f0587ae111828.svg";
export { ForwardRef as ReactComponent };